import { ReactElement } from "react";
import Create from "@shared/FormTemplates/Create";
import CreateForm from "./CreateForm";
import createItemAPI from "@services/Clients/WhaleShark/benefits/createItem";
import validator from "@validators/Clients/WhaleShark/benefits/Benefits.validate";
import formMapper from "@mappers/Clients/WhaleShark/benefits/benefits.mapper";

const CreateItem = (): ReactElement => (
  <Create
    CustomForm={CreateForm}
    createHook={createItemAPI}
    validator={validator}
    formMapper={formMapper}
  />
);

export default CreateItem;
